import { useContext, useEffect, useState } from 'react';

import ArtworkDataContext from '@/context/ArtworkDataContext';
import { NextButton, PrevButton } from '@/shared-components/buttons/components/SliderControls';

import LimitedEditionRoomPreview from './components/LimitedEditionRoomPreview';
import PicturesSlider from './components/PicturesSlider';

import './index.css';

export default function PicturesSection() {
  const { artworkData, limitedEditionPreviewState } = useContext(ArtworkDataContext);
  const secondaryPictures = Array.isArray(artworkData?.artwork_media?.artwork_secondary_pictures)
    ? artworkData.artwork_media.artwork_secondary_pictures
    : [];
  const [activeSlide, setActiveSlide] = useState(0);
  const [swiper, setSwiper] = useState(null);
  // The preview flag switches the slider into the staged room layout during the limited edition flow.
  const hasPreviewSelection = Boolean(limitedEditionPreviewState?.selectedSizeData);
  const isPreviewActive = Boolean(limitedEditionPreviewState?.isVisible && hasPreviewSelection);

  useEffect(() => {
    // Reset the slider position whenever a new artwork loads so the dot
    // indicators and the picture start from the first image.
    setActiveSlide(0);
    if (swiper) {
      swiper.slideTo(0, 0);
    }
  }, [artworkData._id, swiper]);

  useEffect(() => {
    if (!swiper || isPreviewActive) {
      return undefined;
    }

    // Función para manejar la flecha izquierda
    const handleArrowLeft = (event) => {
      if (event.key === 'ArrowLeft') {
        swiper?.slidePrev();
      }
    };

    // Función para manejar la flecha derecha
    const handleArrowRight = (event) => {
      if (event.key === 'ArrowRight') {
        swiper?.slideNext();
      }
    };

    // Agregar los event listeners
    window.addEventListener('keydown', handleArrowLeft);
    window.addEventListener('keydown', handleArrowRight);

    // Cleanup: quitar los event listeners cuando el componente se desmonte
    return () => {
      window.removeEventListener('keydown', handleArrowLeft);
      window.removeEventListener('keydown', handleArrowRight);
    };
  }, [swiper, isPreviewActive]);
  
  return (
    <>
      <div className="artwork-view-pictures-section__container">
        {isPreviewActive ? (
          <LimitedEditionRoomPreview
            artworkData={artworkData}
            previewState={limitedEditionPreviewState}
          />
        ) : (
          <>
            <PicturesSlider setActiveSlide={setActiveSlide} setSwiper={setSwiper} />

            {secondaryPictures.length > 0 && (
              <div className="artwork-view-pictures-slider__control-indicators-container">
                <div className="artwork-view-pictures-slider__control-outter prev" onClick={() => swiper?.slidePrev()}>
                  <PrevButton className={`artwork-view-pictures-slider__control ${activeSlide === 0 ? "disabled" : ""}`} />
                </div>

                <div className="artwork-view-pictures-section__slide-indicators">
                  <div className={`artwork-view-pictures-section__slide-indicator${activeSlide === 0 ? " active" : ""}`} />

                  {secondaryPictures.map((secondaryPicture, index) => (
                    <div key={secondaryPicture.image_id} className={`artwork-view-pictures-section__slide-indicator ${activeSlide === (index + 1) ? "active" : ""}`} />
                  ))}
                </div>

                <div className="artwork-view-pictures-slider__control-outter next" onClick={() => swiper?.slideNext()}>
                  <NextButton className={`artwork-view-pictures-slider__control ${activeSlide === secondaryPictures.length ? "disabled" : ""}`} />
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
